import Cookies from 'js-cookie'
const authKey = 'admin-auth'
const TokenKey = 'uToken'
// 存储token
export function setToken (token) {
  return Cookies.set(TokenKey, token)
}
// 获取token
export function getToken () {
  return Cookies.get(TokenKey)
}
// 移除token
export function removeToken () {
  return Cookies.remove(TokenKey)
}
// 存储用户名称
export function setCookie (ck, value) {
  return Cookies.set(ck, value)
}
// 获取用户名称
export function getCookie (ck) {
  return Cookies.get(ck)
}
// 移除用户名称
export function removeCookie (ck) {
  return Cookies.remove(ck)
}
// 存储用户信息
export function setAuth (auth) {
  return localStorage.setItem(authKey, auth)
}
// 获取用户信息
export function getAuth () {
  return localStorage.getItem(authKey)
}
// 移除用户信息
export function removeAuth () {
  return localStorage.removeItem(authKey)
}
